import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ProvidersService } from "../../../../_services/providers.service";
import { BreadcrumbService } from "../../../../_services/breadcrumb.service";

@Component({
  selector: "app-provider-users",
  templateUrl: "./provider-users.component.html",
  styleUrls: ["./provider-users.component.css"],
})
export class ProviderUsersComponent implements OnInit {
  filters = {};

  constructor(
    private route: ActivatedRoute,
    private service: ProvidersService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.filters["entity_id"] = this.route.snapshot.parent.params.id;
  }

  ngOnInit() {
    this.service.getProvider(this.filters["entity_id"]).subscribe((data) => {
      this.breadcrumbService.changeBreadcrumbs(
        this.breadcrumbService.setForProvider(data.result, "users")
      );
    });
  }
}
